<template>
  <Modal size="small" @modalClose="onClose">
    <div class="modal-header">
      <h4>สร้างผังรายการ</h4>
      <button
        type="button"
        @click.stop="onClose"
        class="btn btn-link btm-sm btn-close-container">
        <i class="fas fa-times"></i>
      </button>
    </div>
    <form v-on:submit.prevent="onSubmit">
      <div class="modal-body">
        <FormGroup :errorMessage="createScheduleTemplateState.error.name">
          <h5 class="name">เลือกช่วงวันที่ต้องการสร้างผัง</h5>
          <RangeDatePicker
            :dateRange.sync="dateRange" />
        </FormGroup>
        <FormGroup>
          <h5 class="name">สร้างจากเทมเพลต</h5>
          <SelectOption
            :value="scheduleTemplate.dailyScheduleTemplateId"
            :options="templates"
            :customLabel="'name'"
            :placeholder="'เลือกเทมเพลต'"
            @onChanged="onSelectedTemplate"
            @onSearch="loadscheduleTemplates" />
        </FormGroup>
      </div>
      <div class="modal-footer">
        <button type="button"
          class="btn btn-link pl-0"
          @click.stop="onClose">
          ยกเลิก
        </button>
        <button type="submit"
          class="btn btn-primary"
          :disabled="!isValid">สร้างผังตามวันที่เลือก
        </button>
      </div>
    </form>
  </Modal>
</template>

<script>
import _ from 'lodash';
import scheduleManagement from '@/utils/scheduleManagement';
import Modal from '@/components/Modal.vue';
import FormGroup from '@/components/FormGroup.vue';
import SelectOption from '@/components/SelectOption.vue';
import RangeDatePicker from '@/components/RangeDatePicker.vue';
import { loadscheduleTemplates } from '@/scheduleTemplate/api';

import { createScheduleDaily } from './api';

export default {
  mixins: [scheduleManagement],
  props: {
    scheduleDate: {
      type: String,
      default: () => {},
    },
    onLoadSchedule: {
      type: Function,
      default: () => {},
    },
    onClose: {
      type: Function,
      default: () => {},
    },
  },
  components: {
    Modal,
    FormGroup,
    SelectOption,
    RangeDatePicker,
  },
  data() {
    return {
      templates: [],
      dateRange: {
        startDate: null,
        endDate: null,
      },
      scheduleTemplate: {
        dailyScheduleTemplateId: null,
      },
      createScheduleTemplateState: {
        isSaving: false,
        isSaved: false,
        error: {
          name: null,
        },
      },
    };
  },
  created() {
    this.loadscheduleTemplates();
    this.dateRange.startDate = _.cloneDeep(new Date(this.scheduleDate));
    this.dateRange.endDate = _.cloneDeep(new Date(this.scheduleDate));
  },
  computed: {
    isValid() {
      return this.dateRange.startDate && this.scheduleTemplate.dailyScheduleTemplateId && !this.createScheduleTemplateState.isSaving;
    },
  },
  methods: {
    async loadscheduleTemplates(filter) {
      const response = await loadscheduleTemplates(filter);
      this.templates = response.data.data;
    },
    async onSubmit() {
      this.createScheduleTemplateState.isSaving = true;
      this.createScheduleTemplateState.isSaved = false;
      try {
        const payload = { ...this.scheduleTemplate, ...this.dateRange };
        const response = await createScheduleDaily(payload);
        const dailySchedule = this.getFirstDailySchedules(response.data.dailySchedules);
        this.generateRouterLinkByDate(dailySchedule.date);
      } catch (error) {
        this.createScheduleTemplateState.isSaving = false;
        this.createScheduleTemplateState.error = error.response.data;
      }
    },
    generateRouterLinkByDate(schedule) {
      const { scheduleYear, scheduleMonth, scheduleDate } = this.transformDateToParams(schedule);
      // isSame Current Path
      const newPath = `/schedules/${scheduleYear}/${scheduleMonth}/${scheduleDate}`;
      if (this.$route.fullPath !== newPath) {
        this.$router.push(`/schedules/${scheduleYear}/${scheduleMonth}/${scheduleDate}`);
      } else {
        this.onLoadSchedule(scheduleYear, scheduleMonth, scheduleDate);
      }
    },
    getFirstDailySchedules(dailySchedules) {
      return _.head(dailySchedules);
    },
    checkRequired(event) {
      if (!event.target.value) {
        this.createScheduleTemplateState.error = {
          ...this.createScheduleTemplateState.error,
          name: 'ระบุชื่อเทมเพลต',
        };
      } else {
        this.createScheduleTemplateState.error = {
          ...this.createScheduleTemplateState.error,
          name: null,
        };
      }
    },
    onSelectedTemplate(selectOption) {
      this.scheduleTemplate.dailyScheduleTemplateId = selectOption;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

.modal-body {
  overflow: initial;
  padding-top: $spacer * 1.5;
}

.modal-footer {
  justify-content: flex-start;

  .btn:last-child {
    margin-left: auto;
  }
}
</style>
